import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { useUserInfo } from "../../../context/user";

const CustomiseYourAIExperience = ({ onTypeClick, products }) => {
  const userTypes = [
    {
      title: "Business",
      description: "Automate operations and unlock growth with AI Agents.",
    },
    {
      title: "Developer",
      description: "Use APIs and code to create and deploy advanced AI Agents.",
    },
    {
      title: "Agency",
      description:
        "Deliver smarter campaigns and retain more clients with AI Agents.",
    },
    {
      title: "Individual",
      description:
        "Boost productivity and creativity with personalised AI support.",
    },
  ];

  const userInfo = useUserInfo()[0];
  const userActiveLocation = useUserInfo()[4];
  const planId = userActiveLocation?.plan_id || userInfo?.plan_id;
  const activePlan = products?.find(item =>
    item?._id?.toString() === planId?.toString() ||
    item?.monthly_id === planId ||
    item?.yearly_id === planId
  );
  const isDeveloperPlan = activePlan?.developer_plan === true || userInfo?.developer_plan === true || userInfo?.developer_plan === "true";

  const filteredUserTypes = isDeveloperPlan ? userTypes : userTypes.filter(item => item.title !== "Developer");

  return (
    <div className="w-full">
      <div className="w-full flex items-center justify-center">
        <div
          className="container-main w-full self-center mt-5"
          style={{ background: "white" }}
        >
          <div className="w-full" style={{ background: "white" }}>
            <div className="text-center pb-5">
              <h1 className="text-[30px] font-medium">
                Let's Start Building Your AI Agent Team
              </h1>
              <p className="mt-4">
                Tell us who you are so we can tailor Your AI Agents
              </p>
            </div>
            <div className="flex items-center justify-center">
              <div className="grid">
                {filteredUserTypes.map((item, index) => {
                  const isDisabled = isDeveloperPlan && item.title !== "Developer";
                  return (
                    <div
                      key={index}
                      className={`group ${isDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
                      onClick={() => !isDisabled && onTypeClick(item.title)}
                    >
                      <div className={`w-[420px] h-[108px] mt-5 border border-[#D9D9D9] ${!isDisabled && "group-hover:bg-[#F6F0FF] group-hover:border-[#9747FF]"} pl-[35px] pr-7 rounded-md flex items-center justify-between`}>
                        <div className="flex flex-col items-start gap-1">
                          <b>{item.title}</b>
                          <p className="text-left">{item.description}</p>
                        </div>
                        <div className={`hidden ${!isDisabled && "group-hover:flex"}`}>
                          <ArrowForwardOutlinedIcon className="text-[20px]" />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomiseYourAIExperience;
